<template>
	<!-- 点 -->
	<div class="treatment-schedule-dot">
		<div class="dot" :style="{ backgroundColor: color }"></div>
		<div class="shadow" :style="{ backgroundColor: color }"></div>
	</div>
</template>

<script>
export default {
	name: 'treatment-schedule-dot',
	props: {
		color: {
			type: String,
			default: ''
		}
	},
	data() {
		return {

		}
	},
	mounted() {

	},
	methods: {

	}
}
</script>

<style scoped lang="scss">
.treatment-schedule-dot {
	position: relative;
	width: 10px;
	height: 10px;
	margin: 0 auto;
	.dot {
		position: relative;
		z-index: 2;
		width: 100%;
		height: 100%;
		border-radius: 2px;
	}
	.shadow {
		position: absolute;
		top: 4px;
		width: 100%;
		height: 100%;
		z-index: 0;
		filter: blur(5px);
		transform: scale(.6);
		opacity: .8;
	}
}
</style>
